import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type EnrollmentPrimaryActionCardProps = {
  showActionRequired?: boolean;
  actionRequiredLabel?: string;
  children: ReactNode;
  hint?: string | null;
  className?: string;
};

/** Card lateral desktop: Ação Necessária + botão + texto de apoio (sem preço). */
export function EnrollmentPrimaryActionCard({
  showActionRequired = false,
  actionRequiredLabel = "Ação Necessária",
  children,
  hint,
  className,
}: EnrollmentPrimaryActionCardProps) {
  return (
    <div
      className={cn(
        "bg-card-surface p-8 rounded-xl border border-card-border shadow-xl shadow-black/5 dark:shadow-none hover:shadow-2xl hover:shadow-primary/5 transition-all w-full",
        className)}
    >
      {showActionRequired ? (
        <div className="flex items-center gap-2 mb-4">
          <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
          <span className="text-orange-500 text-xs font-bold tracking-wider animate-pulse">
            {actionRequiredLabel}
          </span>
        </div>
      ) : null}
      {children}
      {hint ? (
        <p className="text-center text-muted-foreground text-sm mt-4">{hint}</p>
      ) : null}
    </div>
  );
}
